export enum OrganizationUserSourceEnum {
  REGISTER_BY_PLATFORM = 1,
  INVITATION = 2,
}
